export default __webpack_public_path__ + "static/media/icons-history-18-px.7cc961d0.svg";